export default {"src":"/_next/static/media/IconHand.07d7d339.svg","height":31,"width":28,"blurWidth":0,"blurHeight":0};